import React from 'react';
import './SummaryStats.css';

// 전력 단위 자동 변환 함수 (kW 기준, 소수점 포함 6자리수 이상부터 변환)
const formatPower = (valueInKw) => {
  if (!valueInKw || valueInKw === 0) {
    return {
      value: '0',
      unit: 'kW'
    };
  }
  
  // 정수 부분의 자리수 계산 (소수점 제외)
  const integerPart = Math.floor(Math.abs(valueInKw));
  const digitCount = integerPart.toString().length;
  
  // 6자리수(999,999)를 넘으면 다음 단위로 변환
  if (digitCount > 6) {
    if (digitCount > 15) {
      // 16자리 이상 → PW (페타와트)
      return {
        value: (valueInKw / 1000000000000000).toFixed(3),
        unit: 'PW'
      };
    } else if (digitCount > 12) {
      // 13자리 이상 → TW (테라와트)
      return {
        value: (valueInKw / 1000000000000).toFixed(3),
        unit: 'TW'
      };
    } else if (digitCount > 9) {
      // 10자리 이상 → GW (기가와트)
      return {
        value: (valueInKw / 1000000000).toFixed(3),
        unit: 'GW'
      };
    } else {
      // 7자리 이상 → MW (메가와트)
      return {
        value: (valueInKw / 1000000).toFixed(3),
        unit: 'MW'
      };
    }
  } else {
    // 6자리 이하 → kW (킬로와트)
    return {
      value: Math.round(valueInKw).toLocaleString(),
      unit: 'kW'
    };
  }
};

const SummaryStats = ({ summaryData }) => {
  // 총 발전량 단위 변환
  const totalPowerFormatted = formatPower(summaryData?.totalPowerGeneration || 0);
  
  const stats = [
    {
      label: '총 발전소',
      value: summaryData?.totalCount || 0,
      unit: '개',
      color: '#3b82f6',
      icon: '🏭'
    },
    {
      label: '정상 운영',
      value: summaryData?.normalCount || 0,
      unit: '개',
      color: '#10b981',
      icon: '✅'
    },
    {
      label: '오류 발생',
      value: summaryData?.errorCount || 0,
      unit: '개',
      color: '#ef4444',
      icon: '⚠️'
    },
    {
      label: '총 발전량',
      value: totalPowerFormatted.value,
      unit: totalPowerFormatted.unit,
      color: '#f59e0b',
      icon: '⚡'
    },
    {
      label: '평균 효율',
      value: summaryData?.averageEfficiencyPercentage || 0,
      unit: '%',
      color: '#8b5cf6',
      icon: '📊'
    }
  ];

  return (
    <div className="summary-stats">
      <h3>발전소 현황 요약</h3>
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: stat.color + '20' }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <div className="stat-value" style={{ color: stat.color }}>
                {stat.value.toLocaleString()}
                <span className="stat-unit">{stat.unit}</span>
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryStats;
